<template>
  <CModal
    v-if="modal"
    :show.sync="modal"
    :no-close-on-backdrop="true"
    :centered="true"
    :title="title"
    size="lg"
    class="doctor-list-modal viw-medicine-modal input-container small-table-padding"
  >
    <div>
      <CRow>
        <CCol xs="12" lg="12">
          <table class="table">
            <tbody>
              <tr>
                <th>Name</th>
                <td>{{medicine.name}}</td>
              </tr>
              <tr>
                <th>Cost</th>
                <td>{{medicine.cost}}</td>
              </tr>
              <tr>
                <th>Has manufacturer</th>
                <td>{{medicine.has_manufacturer}}</td>
              </tr>
              <tr>
                <th>Has expiry</th>
                <td>{{medicine.has_expiry}}</td>
              </tr>
              <tr>
                <th>Has batch</th>
                <td>{{medicine.has_batch}}</td>
              </tr>
              <tr>
                <th>has model</th>
                <td>{{medicine.has_model}}</td>
              </tr>
              <tr>
                <th>Specific details</th>
                <td>{{medicine.specific_details | toString}}</td>
              </tr>
              <tr>
                <th>Mode</th>
                <td>{{medicine.details && medicine.details.mode ? medicine.details.mode : "-"}}</td>
              </tr>
              <tr>
                <th>Size</th>
                <td>{{medicine.details && medicine.details.size ? medicine.details.size : "-"}}</td>
              </tr>
              <tr>
                <th>Power</th>
                <td>{{medicine.details && medicine.details.power ? medicine.details.power : "-"}}</td>
              </tr>
              <tr>
                <th>Dosage</th>
                <td>{{medicine.details && medicine.details.dosage ? medicine.details.dosage : "-"}}</td>
              </tr>
              <tr>
                <th>Quantity</th>
                <td>{{medicine.details && medicine.details.quantity ? medicine.details.quantity : "-"}}</td>
              </tr>
              <tr>
                <th>Generic name</th>
                <td>{{medicine.details && medicine.details.generic_name ? medicine.details.generic_name : "-"}}</td>
              </tr>
              <tr>
                <th>Manufacturer</th>
                <td>{{medicine.details && medicine.details.manufacturer ? medicine.details.manufacturer : "-"}}</td>
              </tr>
              <tr>
                <th>Is verified</th>
                <td>{{medicine.is_verified ? 'Verified' : 'Not verified'}}</td>
              </tr>
            </tbody>
          </table>
        </CCol>
      </CRow>
    </div>
    <template #footer>
      <CButton variant="outline" color="danger" class="mr-2" @click="modal = false">Close</CButton>
      <CButton
        variant="outline"
        color="success"
        class="mr-2"
        @click="confirm"
        v-if="!medicine.is_verified"
      >Verify</CButton>
    </template>
  </CModal>
</template>
<script>
import Swal from "sweetalert2";
import config from "@/config.js";
export default {
  filters: {
    toString: function(value) {
      if (!value) return "";
      value = value.toString();
      return value;
    }
  },
  data() {
    return {
      modal: false,
      medicine: {},
      title: "View medicine"
    };
  },
  methods: {
    showModal(data) {
      this.medicine = data;
      this.modal = true;
    },
    confirm() {
      Swal.fire({
        title: "Are you sure",
        text: `You want to verify ${this.medicine.name} medicine?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      }).then(result => {
        if (result.isConfirmed) {
          this.verifyMedicine();
        }
      });
    },
    verifyMedicine() {
      let url = `${config.PHARMACY_URL}api/v1/admin/master-stock/${this.medicine.id}/verify`;
      this.$http
        .put(url, {})
        .then(res => {
          this.$emit("refreshList");
          Swal.fire(res.body.message);
          this.medicine.is_verified = true;
        })
        .catch(err => {
          Swal.fire(res.body.message);
        });
    }
  }
};
</script>